
import { 
  defineComponent, 
  computed, 
  SetupContext,
  PropType
} from "vue";
import NativeClient from "@/client/native-client";
import ShoppingIngredientListItem from "@/components/shoppingList/ShoppingIngredientListItem.vue";
import { ShoppingListFoodListItem } from "@/types/shoppingList"

export default defineComponent({
  name: "ShoppingCategoryListItem",
  components: { ShoppingIngredientListItem },
  props: {
    /** カテゴリー名 */
    categoryName: {
      type: String,
      required: true
    },
    /** 食材リスト */
    foodList: {
      type: Array as PropType<ShoppingListFoodListItem[]>,
      required: true
    },
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("ShoppingCategoryListItem setup foodList = " + JSON.stringify(props.foodList));
    const categoryTitle = `【${props.categoryName}】`

    const checkClick = (id: number, check: boolean) => {
      // checkは押された後の値
      NativeClient.sendDebugLog("ShoppingCategoryListItem checkClick id = " + id);
      context.emit("check-click", id, check)
    }
    const editClick = (id: number, foodId: number) => {
      NativeClient.sendDebugLog("ShoppingCategoryListItem editClick id = " + id + ", foodId = " + foodId);
      context.emit("edit-click", id, foodId);
    };

    return {
      categoryTitle,
      checkClick,
      editClick
    };
  }
});
